import { render, staticRenderFns } from "./PostingData.vue?vue&type=template&id=23c52d37"
import script from "./PostingData.vue?vue&type=script&lang=js"
export * from "./PostingData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports